<nb-card class="offer-request-card">
	<nb-card-body class="overflow-visible">
		@if (!shouldHideForIso27701()) {
			<outsourced-process [order]="order" [product]="product" [blocked]="blocked"></outsourced-process>
		}

		<div class="binary-questions-wrapper">
			@for (binaryQuestion of binaryQuestions; track binaryQuestion.type; let i = $index) {
				<div class="margin-bottom25">
					<binary-question-with-comment [binaryQuestionHtmlID]="binaryQuestionRadioControlName(i)" [binaryQuestionControlName]="binaryQuestionRadioControlName(i)"
												  [textAreaHtmlID]="binaryQuestionDescriptionControlName(i)" [textAreaControlName]="binaryQuestionDescriptionControlName(i)"
												  [question]="binaryQuestion" [textAreaPlaceHolder]="getPlaceholderText(binaryQuestion)" [autoGrowEnabled]="true" [form]="form"
												  [formService]="formService" [formKey]="product.standard.name"></binary-question-with-comment>
					@if (binaryQuestionTranslationVisible(binaryQuestion)) {
						<translation-field [standard]="product.standard.name" [previewMode]="!translateClientsData"
										   [translatedText]="binaryQuestionTranslatedText(binaryQuestion)"
										   [translationSubject]="getTranslationSubjectForBinaryQuestion(binaryQuestion)"></translation-field>
					}
				</div>
			}
		</div>

		@for (group of groupedTextQuestions | async | keyvalue; track group.key) {
			<div>
				@for (textQuestion of group.value; track textQuestion.index; let i = $index) {
					<div>
						@if (textQuestion.group !== 'DEFAULT' && i == 0) {
							<div class="group-label">
								<label>{{ getGroupName(textQuestion.group) | async }}</label>
							</div>
						}
						<div class="margin-bottom20">
							<text-area [dataTestId]="'text-question-' + textQuestion.type + '-' + product.standard.name"
									   [htmlPrefix]="textQuestionControlName(textQuestion.index)" [placeholder]="'common.text-area-placeholder' | translate" [label]="textQuestion.question"
									   [autoGrowEnabled]="true"
									   [formService]="formService" [formKey]="product.standard.name" [form]="form" [controlName]="textQuestionControlName(textQuestion.index)"
									   [description]="textQuestion.description"></text-area>
							@if (textQuestionTranslationVisible(textQuestion)) {
								<translation-field [standard]="product.standard.name" [previewMode]="!translateClientsData"
												   [translatedText]="textQuestionTranslatedText(textQuestion)"
												   [translationSubject]="getTranslationSubjectForTextQuestion(textQuestion)"></translation-field>
							}
						</div>
					</div>
				}
			</div>
		}
	</nb-card-body>
</nb-card>

